import { Icon } from '../../../elements/images/Icon'

export const StarIcon = Icon
